import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { initializeDefaultAppCheck } from "./firebaseAppCheck";

// Your Firebase configuration details
const firebaseConfig = {
  apiKey: "AIzaSyDmMo9Xhag4ha3EODGZ3TRCYqSZ6p2kaVc",
  authDomain: "andus-education.firebaseapp.com",
  projectId: "andus-education",
  storageBucket: "andus-education.appspot.com",
  messagingSenderId: "539197944862",
  appId: "1:539197944862:web:2f25e52ead88f3ab5eea0f",
  measurementId: "G-B8MVPJZ3L0",
};

// Firebase configuration validation logs removed (too noisy in console).

// Initialize Firebase
const app = initializeApp(firebaseConfig);
initializeDefaultAppCheck();
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
/** Explicit region so callable URLs match deployed functions (avoids wrong endpoint / pseudo-CORS failures). */
const functions = getFunctions(app, "us-central1");

// A single env var drives both this SDK instance and platformAccessApi's own
// fetch-based callable client (see callableUrl() there) toward the local
// Functions emulator instead of the deployed backend.
const functionsEmulatorOrigin = String(
  process.env.REACT_APP_FIREBASE_FUNCTIONS_ORIGIN || "",
).trim().replace(/\/$/, "");
const localFunctionsEmulatorMatch = /^https?:\/\/(?:localhost|127\.0\.0\.1)(?::(\d+))?$/i
  .exec(functionsEmulatorOrigin);
if (localFunctionsEmulatorMatch) {
  connectFunctionsEmulator(
    functions,
    "127.0.0.1",
    Number(localFunctionsEmulatorMatch[1]) || 5001,
  );
}

// Export the initialized services to use them in your components
export { auth, db, storage, functions };
